require('angular');
require('./angular-loggly-logger');
module.exports = 'logglyLogger';



//////////////////
// WEBPACK FOOTER
// ../~/angular-loggly-logger/index.js
// module id = 728
// module chunks = 1